module.exports = "/img/_/_/_/assets/images/card/type//dice_modifier.png?03f2f96321b35b70c9f6783131c7c5c2";